/**
 * Use to link to a Project when we don't need permission editing.
 */

import {Icon} from '@wandb/weave/components/Icon';
import {Tooltip} from '@wandb/weave/components/Tooltip';
import React from 'react';

import {useViewer} from '../../state/viewer/hooks';
import {
  AccessOptions,
  getIconForProjectAccess,
  getProjectAccess,
  getTooltipTextForProjectAccess,
} from '../../util/permissions';
import {project as projectUrl} from '../../util/urls';
import {Link} from './Link';

type LinkProjectProps = {
  entityName: string;
  projectName: string;
  access?: AccessOptions;
};

export const LinkProject = ({
  entityName,
  projectName,
  access,
}: LinkProjectProps) => {
  const url = projectUrl({
    entityName,
    name: projectName,
  });

  const viewer = useViewer();
  const isTeam = entityName !== viewer?.username;

  let iconComponent = null;
  if (access) {
    const projectAccess = getProjectAccess(access);
    const icon = (
      <Icon
        name={getIconForProjectAccess(projectAccess, isTeam)}
        width={16}
        height={16}
        style={{marginRight: '4px'}}
      />
    );
    const desc = getTooltipTextForProjectAccess(projectAccess, isTeam);
    iconComponent = (
      <Tooltip position="top center" content={desc} trigger={icon} />
    );
  }

  return (
    <span style={{display: 'inline-flex', alignItems: 'center'}}>
      {iconComponent}
      <Link to={url}>{projectName}</Link>
    </span>
  );
};
